<template>
	<div ref="salesByDealerRing" style="min-height: 400px;"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";


export default {
	props : ['data'],
	data () {
		return {
			chart : null,
			label : null
		}
	},
	mounted () {
		this.createChart()
		this.processData()
	},
	watch : {
		data : function () {
			this.processData()
		}
	},
	methods : {
		processData () {
			let length = this.chart.data.length

			let data = null
			let total = 0

			if(!this.data) {
				data = [{
					value : 1,
					dataLabel : 'No Data'
				}]
			}
			else {
				data = []

				let keys = Object.keys(this.data)
				keys.forEach((val) => {
					let obj = {}

					obj.value = this.data[val]
					obj.dataLabel = this.toCapitalizedWords(val)
					total += obj.value

					data.push(obj)
				})

				// console.log(data)
			}

			this.label.text = `Total Sales\n${this.numberWithCommas(total)}`;

			this.chart.addData(data , length);
		},
		createChart () {
			this.chart = am4core.create(this.$refs.salesByDealerRing, am4charts.PieChart);

			this.chart.colors.list = [
				am4core.color("#B1E5FD"),
				am4core.color("#FFCDD1"),
				am4core.color("#B1DFDB"),
				am4core.color("#C3DFB1"),
				am4core.color("#CDB1DF")
			]

			let pieSeries = this.chart.series.push(new am4charts.PieSeries());
			pieSeries.dataFields.value = "value";
			pieSeries.dataFields.category = "dataLabel";

			this.chart.innerRadius = am4core.percent(50);

			// Put a thick white border around each Slice
			pieSeries.slices.template.stroke = am4core.color("#fff");
			pieSeries.slices.template.strokeWidth = 2;
			pieSeries.slices.template.strokeOpacity = 1;
			pieSeries.slices.template
			// change the cursor on hover to make it apparent the object can be interacted with
			.cursorOverStyle = [
				{
				"property": "cursor",
				"value": "pointer"
				}
			];

			pieSeries.labels.template.adapter.add("radius", (radius, target) => {
				if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
					return am4core.percent(2.5);
				} 
				return radius;
			})

			pieSeries.ticks.template.disabled = true;
			pieSeries.alignLabels = false;
			pieSeries.labels.template.text = "[bold]{value.percent.formatNumber('#.0')}%";
			pieSeries.labels.template.bent = true;
			pieSeries.labels.template.radius = am4core.percent(-25);
			pieSeries.labels.template.fill = am4core.color("#FFF");
			pieSeries.labels.template.padding(0,0,0,0);

			// Create a base filter effect (as if it's not there) for the hover to return to
			let shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
			shadow.opacity = 0;

			// Create hover state
			let hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

			// Slightly shift the shadow and make it more prominent on hover
			let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter);
			hoverShadow.opacity = 0.7;
			hoverShadow.blur = 5;

			// Add a legend
			this.chart.legend = new am4charts.Legend();
			this.chart.legend.useDefaultMarker = true;
			// this.chart.legend.maxHeight = 100;
			this.chart.legend.scrollable = true;
			this.chart.legend.position = 'right';
			var marker = this.chart.legend.markers.template;
			// marker.cornerRadius(12, 12, 12, 12);
			marker.width = 5;
			marker.height = 20;


			// Add label
			// this.chart.innerRadius = 100;
			this.label = this.chart.seriesContainer.createChild(am4core.Label);
			this.label.text = "Total Sales\n0";
			this.label.horizontalCenter = "middle";
			this.label.verticalCenter = "middle";
			this.label.textAlign = "middle";
			this.label.fontSize = 20;
		}
	}
}
</script>